// We need to bootstrap the application for the 'Plugins Framework' to work.
import('./main');
export {};
